import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import { BrandService } from '../../../../shared/services/brand.service';
import { Brand } from '../../../models/Brand';
 
@Component({
  selector: 'app-brand-picker',
  templateUrl: './brand-picker.component.html'
})

export class BrandPickerComponent implements OnInit { 

  //input/output parameters
  @Input() title; 
  public brands: Brand[];
  public filteredBrands: Brand[];
  constructor(public activeModal: NgbActiveModal, private brandService: BrandService) { }

  // on component load
  ngOnInit() {
    this.brandService.getAll().subscribe((result) => {
      if (result.length) { 
        this.brands = result.filter(x => x.isActive == true);
        this.filteredBrands = this.brands;
      }
    })
  } 

  decline(): void {
    this.activeModal.close(false);
  }

  dismiss(): void {
    this.activeModal.dismiss();
  }

  // filter locations
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.filteredBrands = this.brands.filter(brand => brand.name.trim().toLowerCase().includes(filterValue.trim().toLowerCase()));
  } 
}
